<template>
  <div>
    <div class="user-card" style="margin-bottom: 20px;">
      <span style="margin-right: 10px;">为</span>
      <img v-if="user.headImg" :src="user.headImg" alt="" />
      <p>{{user.userName}}<span v-if="user.userPhone">({{user.userPhone}})</span><span style="margin-left: 10px;">充值购物券</span></p>
    </div>
    <a-form-model
      layout="horizontal"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 19 }"
      :model="model"
      ref="form"
      :colon="false"
      @submit.native.prevent
      @submit="submit"
    >
      <a-form-model-item label="充值购物券个数" prop="amount" :rules="[
          { required: true, message: '请输入' },
          { pattern: /^(\-)?\d+(\.\d{1,2})?$/, message: '格式不正确' }
        ]">
        <a-input v-model="model.amount" placeholder="请输入充值购物券个数"></a-input>
      </a-form-model-item>

      <a-form-model-item label=" ">
        <a-button type="primary" :loading="loading" @click="submit">提交</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { ref, reactive, watch } from '@vue/composition-api'
import { getSession } from '@/utils/session'
import { SHOPID } from '@/constants'
import { includeFields, wrapAwait } from '@/utils/tools'
import { bean } from '@/api'
import { message } from 'ant-design-vue'

export default {
  name: 'ChargeForm',
  props: {
    type: String, // money voucher
    user: Object,
  },
  setup (props, { emit }) {
    const model = reactive({
      userId: props.user.userId,
      shopId: getSession(SHOPID),
      amount: '',
      productSku: [],
      num: '',
      buyNote: ''
    })

    const loading = ref(false)
    const form = ref(null)
    watch(() => props.user, (v) => {
      model.userId = v.userId
      console.log(model)
    }, { immediate: true, deep: true })
    async function submit () {
      const valid = await form.value.validate()
      if (!valid) return
      loading.value = true
      const [err] = await wrapAwait(
        props.type === 'money'
          ? bean.chargeMoney(includeFields(model, ['userId', 'shopId', 'amount']))
          : bean.chargeVoucher({
            ...includeFields(model,
              ['userId', 'shopId', 'productId', 'num', 'buyNote']
            ),
            productId: model.productSku[0],
            productSkuId: model.productSku[1]
          })
      )
      loading.value = false
      if (err) {
        message.error(err.message)
      } else {
        message.success('提交成功')
        emit('close')
        emit('success')
      }
    }

    return {
      model,
      submit,
      loading,
      form,
    }
  }
}
</script>

<style>

</style>
